module.exports = __webpack_public_path__ + "static/media/website-14.9b9e26e6.png";